import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyDeviceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyDeviceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyDevice = (request: VerifyDeviceRequest, options?: CashRequestOptions) =>
  post<VerifyDeviceRequest, VerifyDeviceResponse>('/2.0/cash/verify-device', request, {
    ...options,
    rejectOnError: true,
  })
